<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'UsefulLinks' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content [scrollEvents]="true">
    <ion-list>
        <ion-list-header *ngIf="addFormShow" class="list-wrap-header">
            <ion-grid>
                <ion-row *ngIf="addFormShow" style="border:1px solid #cccccc">
                    <ion-col size="12">
                        <ion-input placeholder="{{'Title' | translation}}" [(ngModel)]="title"></ion-input>
                        <ion-input type="url" placeholder="Url" [(ngModel)]="url"></ion-input>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="addFormShow" class="ion-text-right">
                    <ion-col size="12">
                        <ion-button (click)="saveUrl()" [disabled]="! url">{{'Save' | translation}}</ion-button>
                        <ion-button (click)="cancelLink()">{{'Cancel' | translation}}</ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-list-header>

        <!-- Admin Links -->
        <ion-item-divider>
            <ion-label>{{'AdminLinks' | translation}}</ion-label>
        </ion-item-divider>
        <ion-item button *ngFor="let link of adminLinks;" (click)="dismiss('copy', link)">
            <p>{{link.title}} - <span style="font-weight: bold;">{{link.language_name}}</span></p>
            <div slot="end">
                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="editLink($event, link)" shape="round" size="small" style="margin-right: 5px;">
                    <ion-icon name="create" slot="icon-only"></ion-icon>
                </ion-button>

                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert($event, link)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item>

        <!-- My Links -->
        <ion-item-divider>
            <ion-label>{{'MyLinks' | translation}}</ion-label>
        </ion-item-divider>
        <ion-item button *ngFor="let link of myLinks;" (click)="dismiss('copy', link)">
            <p>{{link.title}}<span style="font-weight: bold;">{{link.language_name}}</span></p>
            <div slot="end">
                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="editLink($event, link)" shape="round" size="small" style="margin-right: 5px;">
                    <ion-icon name="create" slot="icon-only"></ion-icon>
                </ion-button>

                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert($event, link)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item>

        <!-- <ion-item *ngFor="let link of links;" (click)="dismiss('copy', link)">
            <p>{{link.title}} - <span style="font-weight: bold;">{{link.language_name}}</span></p>
            <div slot="end">
                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="editLink($event, link)" shape="round" size="small" style="margin-right: 5px;">
                    <ion-icon name="create" slot="icon-only"></ion-icon>
                </ion-button>
    
                <ion-button *ngIf="link.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert($event, link)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item> -->
    </ion-list>
</ion-content>